var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('div',{staticClass:"alert alert-danger",attrs:{"show":""}},[_vm._v(_vm._s(_vm.error))]):_c('div',[_vm._t("header"),_vm._v(" "),(_vm.loading)?_c('loading-span',{attrs:{"message":_vm.loadingMessage}}):_c('div',[_vm._t("actions"),_vm._v(" "),_vm._t("body"),_vm._v(" "),_vm._t("actions")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }